import http from './http'

export async function getTerms() {
    return await http.get("/terms", {}).then(response => {
        if (response.status === 200) {
            return response
        }
    }).catch(() => console.error("이용 약관 정보를 얻는데 실패했습니다."))
}

export async function postTerms(request) {
    return await http.post("/admin/terms", JSON.stringify(request))
        .then(response => {
            if (response.status === 201) {
                return response
            }
        }).catch(() => console.error("이용약관 업로드에 실패했습니다."))
}

export async function deleteTerms(id) {
    return await http.delete("/terms", { params: { "id": id } })
        .then(response => {
            if (response.status === 200) {
                return response
            }
        }).catch(() => console.error("이용약관 삭제에 실패했습니다."))
}